export const exhibitionModel = {
  date_from: new Date(),
  date_to: new Date(),
  date_accuracy: 7,
  is_separate: 1
}
